import { render } from "./GradeScore.vue?vue&type=template&id=3796c9d8&scoped=true"
import script from "./GradeScore.vue?vue&type=script&lang=js"
export * from "./GradeScore.vue?vue&type=script&lang=js"

import "./GradeScore.vue?vue&type=style&index=0&id=3796c9d8&scoped=true&lang=css"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=3796c9d8&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3796c9d8"]])

export default __exports__